angular.module('gym.contacts').factory('ConversationLogService', ["$q", "$http", function($q, $http) {
  return {
    get: function(gymId, contactId) {
      var deferred, url;
      deferred = $q.defer();
      url = `gyms/${gymId}/contacts/${contactId}/contact_log_entries.json`;
      $http({
        method: 'GET',
        url: url,
        params: {
          'types[]': 'conversation_log_entry',
          count: 1000
        }
      }).success(function(data) {
        return deferred.resolve(data);
      }).error(function(data) {
        return deferred.reject(data);
      });
      return deferred.promise;
    }
  };
}]);
